export const UPLOAD_CREATE_REQUEST = "UPLOAD_CREATE_REQUEST";
export const UPLOAD_CREATE_SUCCESS = "UPLOAD_CREATE_SUCCESS";
export const UPLOAD_CREATE_FAIL = "UPLOAD_CREATE_FAIL";
export const UPLOAD_CREATE_RESET = "UPLOAD_CREATE_RESET";

export const UPLOAD_DELETE_REQUEST = "UPLOAD_DELETE_REQUEST";
export const UPLOAD_DELETE_SUCCESS = "UPLOAD_DELETE_SUCCESS";
export const UPLOAD_DELETE_FAIL = "UPLOAD_DELETE_FAIL";
export const UPLOAD_DELETE_RESET = "UPLOAD_DELETE_RESET";
